import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import FollowButtons from 'components/FollowButtons';
import HideIf from 'funnel-schedule/HideIf';
import logo from 'static/frn-logo.png';
import logoecf from 'static/logo-ecf.png';
import classNames from 'classnames';
import './FooterTntg.scss';

export default function Footer(props) {
  return (
    <div className={classNames('frn-footer text-center wrapper', props.className)}>
      <Container>
        <Row>
          <Col xs="12">
            <h4 className="text-condensed text-800">
              FREE Screening Of <em>The Need To GROW</em> <br className="d-none d-md-block d-lg-none" />
              Brought To You By:
            </h4>
            <div className="logos mb-3">
              <img className="img-fluid logo-footer logo-ecf" src={logoecf} />
              <img className="img-fluid logo-footer logo-frn" src={logo} />
            </div>
            <div className="social-follow-footer">
              <FollowButtons alignment="justify-content-center" noLike />
            </div>
          </Col>
        </Row>
        <hr className="hr-white-50 my-5" />
        <Row>
          <Col xs="12">
            <div className="frn-disclaimer text-left">
              <p>
                At Food Revolution Network (FRN), our mission is healthy, ethical, sustainable food for all. Information
                and resources shared by FRN are for informational purposes only and are not intended to diagnose, treat,
                or cure any type of disease or condition. Reviews and testimonials of specific diets and approaches to
                health represent individual experiences and FRN does not guarantee any specific results from these
                approaches for your specific situation.
              </p>
              <p>
                In support of our educational mission, we sometimes share resources offered by trusted partners. If you
                purchase products from one of these partners, FRN may at times receive a portion of the proceeds. These
                affiliations support our work and allow us to continue bringing you valuable, life-changing content.{' '}
                <a
                  className="link-underline link-white"
                  href="https://foodrevolution.org/terms-and-conditions/"
                  target="_blank"
                >
                  Here are our full terms & conditions.
                </a>{' '}
                To opt-out of ever having your info sold to 3rd parties under any circumstances,{' '}
                <a
                  className="link-underline link-white"
                  href="https://foodrevolution.org/do-not-sell-my-information/"
                  target="_blank"
                >
                  click here
                </a>
                .
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

Footer.defaultProps = {
  className: 'background-black text-white'
};
